var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report"},[_c('img',{attrs:{"src":"/dashboard/pdf.svg"}}),_c('a',{staticClass:"download-report",on:{"click":_vm.downloadReport}},[_vm._v(" "+_vm._s(_vm.report.file.fileName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }